import React from 'react'
import styled from 'styled-components'
import { provideState, injectState, softUpdate } from 'freactal'
import { flattenTextList, nestTextList } from '../../lib'
import { IconButton } from 'react-mdl'

const DefaultInputComponent = styled.input`
  width: 95%;
  margin-bottom: 2;
`

const withState = provideState({
  initialState: ({ textList, onChange }) => ({
    onChange,
    textList: flattenTextList(textList),
  }),
  effects: {
    handleChangeInput: (effects, { value, index }) => state => {
      clearTimeout(state.saveTimeout)
      const textList = [
        ...state.textList.slice(0, index),
        value,
        ...state.textList.slice(index + 1),
      ]
      return {
        ...state,
        textList,
        saveTimeout: setTimeout(() => {
          state.onChange(nestTextList(textList))
        }, 1500),
      }
    },
    deleteItem: (effects, { index }) => state => {
      clearTimeout(state.saveTimeout)
      const textList = [
        ...state.textList.slice(0, index),
        ...state.textList.slice(index + 1),
      ]
      return {
        ...state,
        textList,
        saveTimeout: setTimeout(() => {
          state.onChange(nestTextList(textList))
        }, 1500),
      }
    },
    addItem: softUpdate(({ textList }) => ({ textList: textList.concat('') })),
  },
})

export default withState(injectState(TextListEditor))

function TextListEditor({
  state: { textList },
  effects: { handleChangeInput, addItem, deleteItem },
  buttonComponent: ButtonComponent = 'button',
  inputComponent: InputComponent = DefaultInputComponent,
}) {
  return (
    <div>
      {textList.map((text, index) =>
        <div key={index}>
          <InputComponent
            onChange={({ target: { value } }) =>
              handleChangeInput({
                value,
                index,
              })}
            value={text}
          />
          <IconButton
            accent
            name="delete"
            type="button"
            onClick={() => deleteItem({ index })}
          />
        </div>,
      )}
      <ButtonComponent onClick={addItem}>Add item</ButtonComponent>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/Units/components/TextListEditor.js